import { useCallback, useState } from "react";

type Returns = [boolean, () => void, () => void, (v: boolean) => void];

const useModalState = () => {
  const [isOpen, setIsOpen] = useState(false);

  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onChangeOpen = useCallback((_isOpen: boolean) => {
    setIsOpen(_isOpen);
  }, []);

  return [isOpen, onOpen, onClose, onChangeOpen] as Returns;
};

export default useModalState;
